// ==========================================================================
// Accordion module
// ==========================================================================
/* jshint esnext: true */
import { APP_NAME } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'AccordionRoute';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.setHeights();

        this.$el.on(EVENT.CLICK, '.js-accordion-header', (event) => {
            let $target = $(event.currentTarget);
            let $section = $target.parents('.js-accordion-section');

            if (!$section.hasClass('is-open')) {
                // Open
                this.open($target, $section);
            }
        });
    }

    setHeights() {
        if (window.matchMedia("(min-width: 1200px)").matches) {
            let heights = [];
            let $content = this.$el.find('.js-accordion-content');

            $content.each(function(index, el) {
                heights.push($(el).outerHeight());
            });

            let maxHeight = Math.max.apply(Math, heights);

            $content.css('height', maxHeight);

            this.$el.find('.js-accordion-main').css({
                display: 'none',
                height: 'auto'
            });

            this.$el.find('.js-accordion-section:first-child').addClass('is-open')
                    .find('.js-accordion-main').css('display', 'block');

            $('.js-scroll').triggerHandler({
                type: 'updateSticky.LocomotiveScroll',
            })
        }
    }

    // Open
    // ==========================================================================
    open($target, $section) {
        this.closeAll();

        $target.siblings('.js-accordion-main').slideDown(300, function() {
            $('.js-scroll').triggerHandler({
                type: 'updateSticky.LocomotiveScroll',
            })
        });
        $section.addClass('is-open').find('.slick-slider').slick('setPosition');
    }

    // Close all
    // ==========================================================================
    closeAll() {
        this.$el.find('.js-accordion-section.is-open')
            .removeClass('is-open')
            .find('.js-accordion-main')
            .slideUp(300, function() {
                $('.js-scroll').triggerHandler({
                    type: 'updateSticky.LocomotiveScroll',
                })
            });
    }

    // Scroll to
    // ==========================================================================
    scrollTo($target, $section) {
        if (this.$el.data('accordion-scroll') !== false) {
            let offset = $('.js-header').height();

            $('.js-scroll').triggerHandler({
                type: 'scrollTo.LocomotiveScroll',
                options: {
                    targetElem: $section,
                    targetOffset: -offset,
                    speed: 300,
                }
            })
        }
    }

    // Destroy
    // ==========================================================================
    destroy() {
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
